@if (message) {
	<div class="snackbar padding margin white {{ show ? 'show' : '' }} {{ type == 'success' ? 'bg-green' : type == 'error' ? 'bg-red' : 'bg-primary' }}">
		<i class="fa-solid fa-circle-info margin-right-small"></i>
		{{ message }}
	</div>
}
